/**
 * Shared client number input validation utilities.
 * Used by any component that has a client number input field.
 * Rules: exactly 6 digits, cannot start with 0.
 */

export function clientNumberKeyPress(event: KeyboardEvent, notifyjs: any): boolean {
    const target = event.target as HTMLInputElement;
    const currentValue = target.value || '';
    const selectionStart = target.selectionStart || 0;

    // Allow: backspace, delete, tab, escape, enter
    if ([8, 9, 27, 13].indexOf(event.keyCode) !== -1 ||
        // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        (event.keyCode === 65 && event.ctrlKey === true) ||
        (event.keyCode === 67 && event.ctrlKey === true) ||
        (event.keyCode === 86 && event.ctrlKey === true) ||
        (event.keyCode === 88 && event.ctrlKey === true)) {
        return true;
    }

    // Prevent input if already at 6 characters
    if (currentValue.length >= 6 && [8, 46].indexOf(event.keyCode) === -1) {
        event.preventDefault();
        return false;
    }

    // Only allow numeric keys: 0-9 (keyCode 48-57) and numpad 0-9 (keyCode 96-105)
    if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105)) {
        // Prevent entering 0 as the first character
        if (event.keyCode === 48 || event.keyCode === 96) {
            if (currentValue.length === 0 || selectionStart === 0) {
                event.preventDefault();
                notifyjs("Client number cannot start with 0", "error");
                return false;
            }
        }
        return true;
    }

    // Block everything else (letters, symbols, etc.)
    event.preventDefault();
    return false;
}

export function clientNumberPaste(event: ClipboardEvent, notifyjs: any): void {
    const pastedText = (event.clipboardData || (window as any).clipboardData).getData('text');

    if (pastedText && pastedText.trim().startsWith('0')) {
        event.preventDefault();
        notifyjs("Client number cannot start with 0", "error");
        return;
    }
}

export function watchClientNumber(newValue: string, oldValue: string, client: any, notifyjs: any): void {
    if (newValue && newValue.startsWith('0')) {
        notifyjs("Client number cannot start with 0", "error");
        if (client) {
            client.clientNumber = oldValue || '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/utils/clientNumberUtils.ts